import React from "react";
import "./ProjectHereBoy.scss";
import GenericHero from "../../components/GenericHero/GenericHero";
import HereBoyImg from "../../assets/images/mockupHereBoy.png";
import Carousel from "../../components/Carousel/Carousel";
import Heading from "../../components/Heading/Heading";
import { hereBoyCarouselContents } from "./hereBoyCarouselContents";
import reactLogo from "../../assets/icons/react.svg";
import sassLogo from "../../assets/icons/sass.svg";
import typeLogo from "../../assets/icons/typescript.svg";
import emailLogo from "../../assets/icons/emailjs.svg";
import netlifyLogo from "../../assets/icons/netlify.svg";
import Button from "../../components/Button/Button";
import { Link } from "react-router-dom";

export default function ProjectHereBoy() {
  return (
    <div className="HereBoyPage">
      <GenericHero
        head="Here Boy!"
        text="A fun coding challenge to create a fake dog adoption website where users can log in, search through the dog database, select their favorites, and get their perfect match!"
        hImg={HereBoyImg}
        hAlt="A mockup of several pages from hereboycodechallenge.netlify.app"
        btnContent="Read More"
        btnLink="#HereBoyDetails"
        btn2Content="Visit Website"
        btn2Link="https://hereboycodechallenge.netlify.app/"
      />
      <section className="HereBoyPage__details" id="HereBoyDetails">
        <Heading content="Details" />
        <div className="HereBoyPage__container">
          <section className="HereBoyPage__content">
            <p className="HereBoyPage__desc">
              Here Boy! started with a coding challenge to create a fake dog
              adoption website. Users are able to log in, search, favorite, and
              be given their perfect match dog all from one page. Although this
              is a React Single Page Application built with TypeScript, I
              focused on delivering all core functionality through a seamless
              and intuitive home/search page.
            </p>
            <p className="HereBoyPage__desc">
              A unique constraint of this project was working without AI or
              large language model assistance. Since I typically use tools like
              these to brainstorm or problem-solve, this was a fun challenge to
              see what I can do with my own understanding. It was a challenge at
              first, but I quickly grew more confident in reading documentation
              and troubleshooting NPM libraries and external APIs independently.
            </p>
            <p className="HereBoyPage__desc">
              I invite you to view the public GitHub repository to see how I
              approached specific problems and structured the codebase. The repo
              includes comprehensive documentation on the current state of the
              code, the challenges I encountered, and my planned next steps.
            </p>
            <Link to={"https://github.com/ZeaZuniga/fetch-challenge-zuniga"}>
              <Button
                classtitle="button button--primary button__hereBoy"
                content="GitHub Repo"
              />
            </Link>
          </section>
          <Carousel items={hereBoyCarouselContents} />
        </div>
      </section>
      <section className="techstack">
        <Heading content="Tech Stack" />
        <div className="techstack__front">
          <p className="techstack__title">Front End</p>
          <ul className="techstack__list">
            <li className="techstack__item">
              <img
                src={reactLogo}
                alt="React Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">React</p>
            </li>
            <li className="techstack__item">
              <img
                src={sassLogo}
                alt="SASS/SCSS Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">SASS/SCSS</p>
            </li>
            <li className="techstack__item">
              <img
                src={typeLogo}
                alt="TypeScript Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">TypeScript</p>
            </li>
            <li className="techstack__item">
              <img
                src={emailLogo}
                alt="Axios Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">Axios</p>
            </li>
            <li className="techstack__item">
              <img
                src={netlifyLogo}
                alt="Netlify Logo"
                className="techstack__logo"
              />
              <p className="techstack__label">Netlify</p>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
}
